import { useCheckAuth } from '@features/user/states';
import { LoadingScreen } from '@g2-shared/components';
import React, { useEffect } from 'react';

interface Props {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: Props) => {
  const { isAuthenticated, isLoading: isLoadingCheckAuth } = useCheckAuth();
  // const { permissions } = useGetClientPermission(!!isAuthenticated);
  // const { pathname } = useLocation();
  // const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && !isLoadingCheckAuth && window.location.href.includes('webapp')) {
      window.location.href = import.meta.env.VITE_APP_LOGIN_URL || window.location.origin;
    }
  }, [isAuthenticated, isLoadingCheckAuth]);

  // useEffect(() => {
  //   if (
  //     pathname !== PARTY_ROUTES.createParty &&
  //     permissions &&
  //     !permissions.subservices?.includes("WUD")
  //   ) {
  //     navigate(PARTY_ROUTES.createParty);
  //   }
  // }, [permissions, pathname]);

  if (isLoadingCheckAuth) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
